export const BULLETIN_VERSION = "1.0.1";
